import React from "react";
import styles from "./UsersDetailsTicketsTab.module.css";
import Card from "shared/Card";
import TicketsList from "./TicketsList";

const ticketList = [
  {
    event: "Spring Leadership",
    jobCode: "2204SLAS",
    name: "Standard",
    id: "SL_STD",
    date: "MM/DD/YYY",
  },
  {
    event: "Spring Leadership",
    jobCode: "2204SLAS",
    name: "Guest",
    id: "SL_GUEST",
    date: "MM/DD/YYY",
  },
  {
    event: "Second Look Meeting",
    jobCode: "2204SLAS",
    name: "Standard",
    id: "SL_STD",
    date: "MM/DD/YYY",
  },
  {
    event: "Spring Leadership",
    jobCode: "2204SLAS",
    name: "Guest",
    id: "SL_GUEST",
    date: "MM/DD/YYY",
  },
];

/**
 * Content in all details ticket page.
 */

export function UsersDetailsTicketsTab() {
  return (
    <>
      <div className={styles.container}>
        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>TICKETS</h5>
            <div className={styles.hr} />
          </div>

          <div className={styles.usersDiv}>
            <TicketsList tickets={ticketList} />
          </div>
        </Card>
      </div>
    </>
  );
}
